import { Button, Modal, Stack, TextInput } from "@mantine/core"
import { DatePickerInput } from "@mantine/dates"
import { useEffect, useState } from "react"
import dayjs from "dayjs"
import { useCreateWorkshop, useUpdateWorkshop } from "../hooks/use-workshops"

interface MSaveWorkshopProps {
  opened: boolean
  onClose: () => void
  editingWorkshop: any | null
}

const emptyWorkshop = {
  tema: "",
  fecha: "",
  expositor: "",
  participantes: ""
}

export function MSaveWorkshop({ opened, onClose, editingWorkshop }: MSaveWorkshopProps) {
  const [workshop, setWorkshop] = useState<typeof emptyWorkshop>(emptyWorkshop)
  const createWorkshopMutation = useCreateWorkshop()
  const updateWorkshopMutation = useUpdateWorkshop()

  useEffect(() => {
    if (editingWorkshop) {
      setWorkshop({
        tema: editingWorkshop.tema || "",
        fecha: editingWorkshop.fecha || "",
        expositor: editingWorkshop.expositor || "",
        participantes: editingWorkshop.participantes || ""
      })
    } else {
      setWorkshop(emptyWorkshop)
    }
  }, [editingWorkshop, opened])

  const handleSave = async () => {
    if (editingWorkshop) {
      await updateWorkshopMutation.mutateAsync({ id: editingWorkshop.id, workshopData: workshop })
    } else {
      await createWorkshopMutation.mutateAsync(workshop)
    }
    onClose()
  }

  return (
    <Modal opened={opened} onClose={onClose} title={editingWorkshop ? "Editar Taller" : "Agregar Nuevo Taller"} centered>
      <Stack>
        <TextInput label="Tema del taller" placeholder="Tema" value={workshop.tema} onChange={(e) => setWorkshop({ ...workshop, tema: e.target.value })} required />
        <DatePickerInput label="Fecha" placeholder="Seleccione fecha" value={workshop.fecha ? dayjs(workshop.fecha).toDate() : null} onChange={(val) => setWorkshop({ ...workshop, fecha: val ? dayjs(val).format("YYYY-MM-DD") : "" })} required />
        <TextInput label="Expositor" placeholder="Expositor" value={workshop.expositor} onChange={(e) => setWorkshop({ ...workshop, expositor: e.target.value })} />
        <TextInput label="Participantes" placeholder="Participantes" value={workshop.participantes} onChange={(e) => setWorkshop({ ...workshop, participantes: e.target.value })} />
        <Button onClick={handleSave} loading={createWorkshopMutation.isPending || updateWorkshopMutation.isPending}>
          Guardar
        </Button>
      </Stack>
    </Modal>
  )
}
